import React from 'react';
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import image from "../../assets/banner-image/our-gallery.jpeg";

// Import images dynamically
import G1 from "../../assets/gallery/gallery1.jpeg";
import G2 from "../../assets/gallery/gallery2.jpeg";
import G3 from "../../assets/gallery/gallery3.jpeg";
import G4 from "../../assets/gallery/gallery4.jpeg";
import G5 from "../../assets/gallery/gallery5.jpeg";
import G6 from "../../assets/gallery/gallery6.jpeg";
// import G7 from "../../assets/gallery/gallery7.jpeg";
import G8 from "../../assets/gallery/gallery8.jpeg";
import G9 from "../../assets/gallery/gallery9.jpeg";
import G10 from "../../assets/gallery/gallery10.jpeg";
// import G11 from "../../assets/gallery/gallery11.jpeg";
import c1 from '../../assets/gallery/c1.jpeg';
import c2 from "../../assets/gallery/c2.jpg";
import c3 from "../../assets/gallery/c3.jpeg";
import c4 from "../../assets/gallery/c4.jpg";
import c5 from "../../assets/gallery/c5.jpg";
import c6 from "../../assets/gallery/c6.jpg";
import c7 from "../../assets/gallery/c7.jpg";
import c8 from "../../assets/gallery/c8.jpg";
import c9 from "../../assets/gallery/c9.jpg";
import c10 from "../../assets/gallery/c10.jpg";
import c11 from "../../assets/gallery/c11.jpg";
import c12 from "../../assets/gallery/c12.jpg";
import c13 from "../../assets/gallery/c13.jpg";
import c14 from "../../assets/gallery/c14.jpg";
import c15 from "../../assets/gallery/c15.jpg";
import c16 from "../../assets/gallery/c16.jpg";
import c17 from "../../assets/gallery/c17.jpg";
import Topheader from '../topheader/Topheader';
import Navcivil from '../navbar/Navcivil';
import Footer from "../footer/Footer";

// import c18 from "../../assets/gallery/c18.jpeg";

// G1, G2, G3, G4, G5, G6, G7, G8, G9, G10, G11,

const images = [ c1,c2,c3,c4,c5,c6,c7,c8,c9,c10,c11,c12,c13,c14,c15,c16,c17,G1, G2, G3, G4, G5, G6, G8, G9, G10];

export default function Gallery() {
  return (
    <>
    <Topheader/>
    <Navcivil/>
     <section>
            <div className="image-about">
              {/* Background Image */}
              <img src={image} alt="About Us" className="image-bg" />
    
              {/* Overlay Content */}
              <div className="overlay-about">
                <h1 className="fade-in-text">Gallery</h1>
              </div>
            </div>
          </section>
    <MDBContainer>
      <div className="row text-center mb-4">
        <div className="col-sm-12">
          <div className="sec_hedding">
            <h3 style={{ marginTop:"20px"}}>Gallery</h3>
            <div className='underline-service'></div>
          </div>
        </div>
      </div>

      <MDBRow className=""> {/* gx-0 removes horizontal gaps */}
        {images.map((image, index) => (
          <MDBCol lg={3} md={4} sm={6} xs={12} key={index} className='p-1'>
            <Zoom>
              <img
                src={image}
                className='w-100 shadow-1-strong rounded'
                alt={`Gallery Image ${index + 1}`}
                style={{ height: '250px', objectFit: 'cover', margin: '0px' }}
              />
            </Zoom>
          </MDBCol>
        ))}
      </MDBRow>
    </MDBContainer>
    <Footer/>
    </>
  );
}
